class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
            Shopify.getCart((cart) => {window.sharedFunctions?.updateSidebarCart(cart)});
          });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);

/* HOX'S 24 Ekim 2026: sepetten kaldırma düzeltmesi.
   Tema kaldırma isteğini satır numarasıyla (line) gönderiyordu; çift dokunuşta ikinci istek artık var olmayan satırı
   hedefleyip sarı "Error : line parametresi geçersiz." uyarısı veriyordu (ve eski numara yanlış ürünü silebilirdi).
   Şimdi ürünün benzersiz anahtarı (id) kullanılıyor ve aynı ürün için ikinci istek yok sayılıyor. */
(function () {
  function patch() {
    if (!window.Shopify || typeof Shopify.removeItem !== 'function' || Shopify.__hoxRemovePatched) return;
    Shopify.__hoxRemovePatched = true;
    var pending = {};
    Shopify.removeItem = function (key, index, callback) {
      var k = String(key || index);
      if (pending[k]) return;
      pending[k] = true;
      var body = JSON.stringify({ id: String(key), quantity: 0, sections_url: window.location.pathname });
      fetch(window.routes.cart_change_url, Object.assign({}, fetchConfig(), { body: body }))
        .then(function (r) { return r.text(); })
        .then(function (t) {
          delete pending[k];
          var s = JSON.parse(t);
          if (s.errors) {
            Shopify.getCart(function (c) { typeof callback === 'function' ? callback(c) : Shopify.onCartUpdate(c); });
            return;
          }
          typeof callback === 'function' ? callback(s) : Shopify.onCartUpdate(s);
        })
        .catch(function (e) { delete pending[k]; console.error(e); });
    };
  }
  if (document.readyState === 'complete') patch(); else window.addEventListener('load', patch);
})();
